import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import './index.scss';
import './ipad.scss';
import './mobile.scss';
import Flecha from '../../img/flecha';
import Gif from '../../img/poppup/giphy.gif';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';


const initialForm = {
    reply_to: 'vladi_ortega@hotmail.com',
    from_name: '',
    userEmail: '',
    concernCategory: '',
    emailTitle: '',
    emailDetails: '',
    name: '',
    lastname: '',
    email: '',
    cell: '',
    company: '',
    taxID: '',
    brand: '',
    industry: '',
    country: '',
    message: 'Tell us a little about what you need : ',
    start: '',
    end: '',
    brandig: '',
    graphic: '',
    web: '',
};

const FormContact = () => {
    const [contact, setContact] = useState(initialForm);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [submitError, setSubmitError] = useState(false);

    const handleChange = e => {
        const { name, value } = e.target;
        setContact({ ...contact, [name]: value });
    };

    const handleSubmit = e => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitError(false);

        emailjs.send('default_service', 'template_ammjr2i', contact, 'akEUA8UHaQ1B4AlAf')
            .then((response) => {
                console.log('SUCCESS!', response.status, response.text);
                setContact(initialForm);
                setIsSubmitting(false);
                setShowPopup(true);
                setTimeout(() => window.location.reload(), 1000);
            }, (err) => {
                console.log('FAILED...', err);
                setIsSubmitting(false);
                setSubmitError(true);
            });
    };

    const SubmitButton = ({ className = "Boton" }) => (
        <button type="submit" className={className} disabled={isSubmitting}>
            <text>{isSubmitting ? 'Sending...' : 'Submit'}</text>
            {!isSubmitting && <Flecha />}
        </button>
    );

    return (
        <div>
            {/* Global success popup (controlled, shows only on success) */}
            <Popup open={showPopup} modal>
                <div className='containerPop' style={{ display: "flex", alignItems: "center", margin: "0", padding: "0" }}>
                    <img src={Gif} width="100%" alt="Message sent!" />
                </div>
            </Popup>

            {/* ── DESKTOP FORM ── */}
            <div className="containerFormContact" id='containerFormContact'>
                <div className="formTitle">
                    <div className="formTitleLeft">
                        Get in touch
                    </div>
                    <div className="formTitleRight">
                        A small step for man. <br />
                        A giant leap for your startup.
                    </div>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="containerFormContent">
                        <div className="containerFormContentLeft">
                            <div className="subtitleForm">
                                <text>Full Name / <tex className='gray'>Nombre Completo</tex></text>
                            </div>
                            <div className="inputForm">
                                <input
                                    type="text"
                                    value={contact.name}
                                    name="name"
                                    onChange={handleChange}
                                    placeholder="Thomas Edwhart"
                                />
                            </div>

                            <div className="subtitleForm">
                                <text>Email / <tex className='gray'>Correo</tex></text>
                                <text>Phone / <tex className='gray'>Tel</tex></text>
                            </div>
                            <div className="inputForm">
                                <input type="text" value={contact.email} name="email" onChange={handleChange} placeholder="email@example.com" />
                                <input type="text" value={contact.cell} name="cell" onChange={handleChange} placeholder="+1(333)333-3333" />
                            </div>

                            <div className="subtitleForm">
                                <text>Country / <tex className='gray'>Pais</tex></text>
                            </div>
                            <div className="inputForm">
                                <input type="text" value={contact.country} name="country" onChange={handleChange} placeholder="USA" />
                            </div>

                            <div className="subtitleForm">
                                <text>How can we help you? / <tex className='gray'>Como podemos ayudarte</tex></text>
                            </div>
                            <div className="inputForm">
                                <textarea className="textarea" rows="5" cols="80" value={contact.message} name="message" onChange={handleChange} />
                            </div>

                            {submitError && (
                                <div className="submitError">
                                    Something went wrong. Please try again or contact us directly.
                                </div>
                            )}

                            <SubmitButton />
                        </div>

                        <div className="containerFormContentRight">
                            <text>Let's build something great together!</text>
                        </div>
                    </div>
                </form>
            </div>

            {/* ── MOBILE FORM ── */}
            <div className="containerFormContactMovil" id='containerFormContactMovil'>
                <div className="formTitle">
                    <div className="formTitleLeft">
                        Get in touch
                    </div>
                    <div className="formTitleRight">
                        Let's build something<br />great together!
                    </div>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="containerFormContent">
                        <div className="containerFormContentLeft">
                            <div className="subtitleForm">
                                <text className="LeftSubtitle">Full Name / <tex className='gray'>Nombre Completo</tex></text>
                                <input type="text" value={contact.name} name="name" onChange={handleChange} placeholder="Thomas" />
                            </div>

                            <div className="subtitleForm">
                                <text>Email / <tex className='gray'>Correo</tex></text>
                                <input type="text" value={contact.email} name="email" onChange={handleChange} placeholder="email@example.com" />
                            </div>
                            <div className="inputForm">
                                <text>Phone / <tex className='gray'>Tel</tex></text>
                                <input type="text" value={contact.cell} name="cell" onChange={handleChange} placeholder="+1(333)333-3333" />
                            </div>

                            <div className="subtitleForm">
                                <text>Country / <tex className='gray'>Pais</tex></text>
                            </div>
                            <div className="inputForm">
                                <input type="text" value={contact.country} name="country" onChange={handleChange} placeholder="USA" />
                            </div>

                            <div className="subtitleForm">
                                <text>How can we help you? / <tex className='gray'>Como podemos ayudarte</tex></text>
                            </div>
                            <div className="inputForm">
                                <textarea className="textarea" rows="5" cols="80" value={contact.message} name="message" onChange={handleChange} />
                            </div>

                            {submitError && (
                                <div className="submitError">
                                    Something went wrong. Please try again.
                                </div>
                            )}

                            <SubmitButton />
                        </div>

                        <div className="containerFormContentRight">
                            Let's build something great together!
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default FormContact;
